import * as React from 'react';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import { toggleEditAccountWindow } from '../actions/editAccount/toggleEditAccountWindow';
import { IconButton, ButtonType } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';

const styles = require('./ConnectedAccountsFull.scss');

export interface EditButtonProps {
    onSelected: (index: number) => void;
    index?: number;
}

@observer
export default class EditButton extends React.Component<EditButtonProps, {}> {
    private onClicked = () => {
        if (this.props.index !== undefined && this.props.index >= 0) {
            this.props.onSelected(this.props.index);
            toggleEditAccountWindow({ editAccountOpen: true });
        }
    };

    render() {
        return (
            <IconButton
                buttonType={ButtonType.command}
                onClick={this.onClicked}
                iconProps={{ iconName: ControlIcons.Edit }}
                className={styles.command}
                title={strings.options_connected_full_editButton}
            />
        );
    }
}
